<template>

  <v-container fluid class="px-10 order-send-email-action" v-if="needsToSend">

    <v-row class="">
      <v-col cols="12" class="d-flex align-center justify-start">
        <template v-if="!notificationsSent">
          <v-icon color="amber darken-1" class="mr-2">mdi-alert-outline</v-icon>
          <div style="font-size:1.1rem;color:#FFB300;">Notifications were not sent</div>
        </template>

        <!-- notifications sending -->
        <v-progress-circular indeterminate :size="18" color="primary" v-if="isNotificationSending" />

        <!-- notifications sent -->
        <template v-else-if="notificationsSent">
          <v-icon color="green" class="mr-4">mdi-check-circle</v-icon>
          <div>Emails Sent!</div>
        </template>

        <!-- send notifications action -->
        <v-btn
            v-else
            large
            color="primary"
            class="ml-8"
            @click="sendNotifications">
          Send Emails
        </v-btn>
      </v-col>
    </v-row>

  </v-container>

</template>

<script>

export default {
  name: 'OrderSendEmailAction',

  data () {
    return {
      isNotificationSending: false,
      notificationSendingError: null,
      notificationsSent: false
    }
  },

  props: {
    order: {
      type: Object,
      required: true
    }
  },

  computed: {
    isCredit () {
      return this.order.is_credit
    },
    needsToSend () {
      return (this.isCredit)
        ? this.order.is_data_ready === false
        : this.order.order_status === 'PLACED' && this.order.is_data_ready === false
    }
  },

  beforeDestroy () {
    // Reload order data if notifications were sent
    if (this.notificationsSent) this.reloadOrderData()
  },

  methods: {
    async reloadOrderData () {
      return this.$parent.reloadOrderData()
    },

    // Completes the order submission process and sets order to "data ready"
    // (NOTE: this will trigger notifications)
    async sendNotifications () {
      try {
        this.isNotificationSending = true

        const uri = (this.isCredit)
          ? `credit/${this.order.id}/data-ready`
          : `order/${this.order.id}/data-ready`
        await this.$store.dispatch('sh/dataApi', {
          method: 'post',
          uri
        })

        this.notificationsSent = true
      } catch (err) {
        this.notificationSendingError = err.message || err.text || err
      } finally {
        this.isNotificationSending = false
      }
    }
  }
}
</script>

<style scoped>
</style>
